import React, { Component } from "react";
import * as _func from "./function";
import { reduxForm } from "redux-form";
import { DateTime } from 'luxon';
import {
  VoteHistoryColumn,
  ViewVoteHisstoryStatusDropDown,
  ViewHisstoryStatusEnum,
  VoteStatusEnum,
  BallotVoteIdThresVal,
  VoteStatusAllEnum,
} from "../../members.model";
import PaginationShorthand from "shared-components/Pager";
import RenderSelect from "shared-components/Select";
import TableHeader from "shared-components/Table/tableHeader";
import { ItemsPerPage } from "models/common.models";
import { Icon, Search } from "semantic-ui-react";
import _, { result } from "lodash";
import CustomTooltip from "shared-components/Tooltip";
import ViewVotetHistoryDetails from "../view-vote-history";
import { encrypt, paginateData } from "../../../../../helpers/util-common";

class MemberVoteHistory extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSearchIcon_Click = this.handleSearchIcon_Click.bind(this);
  }
  state = {
    pageNumber: 1,
    pageSize: 25,
    VoteHistoryList: [],
    sortBy: "SubmissionDate",
    sortOrder: "Asc",
    index: 1,
    TotalRecords: "",
    currentDate: DateTime.now().toFormat('MM-dd-yyyy'),
    beforeOneYearDate: DateTime.now().isInLeapYear
      ? DateTime.now().minus({ days: 366 }).toFormat('MM-dd-yyyy')
      : DateTime.now().minus({ days: 365 }).toFormat('MM-dd-yyyy'),
    voteStatus: -1,
    searchKey: "",
    letterBallotshow: false,
    ballotNumber: null,
    ballotVoteStatus: null,
    showNoResults: false,
  };

  componentDidMount() {
    _func.setInstance(this);
    _func.resetBallotHeaderInfo(VoteHistoryColumn);
    _func.getInitalData();
  }

  handleKeyDown = (e) => {
    if (e.which === 13) {
      if (this.state.searchKey !== "") {
        this.setState(
          {
            value: this.state.value,
            searchKey: this.state.searchKey,
            results: [],
          },
          this.filterUserData
        );
      } else if (this.state.searchKey === "") {
        this.setState(
          { value: "", searchKey: "default", results: [] },
          this.filterUserData
        );
      } else if (this.state.searchKey === "default") {
        this.setState(
          { value: "", searchKey: "default", results: [] },
          this.filterUserData
        );
      }
    }
  };

  handleResultSelect = (e, { result }) => {
    if (result.BallotNumber !== "") {
      this.setState(
        { value: result.BallotNumber, searchKey: result.BallotNumber },
        this.filterUserDataFromResultSelect
      );
    } else {
      this.setState({ value: "", searchKey: "default", pageNo: 1 });
    }
  };

  handleSearchIcon_Click = () => {
    if (this.state.searchKey !== "") {
      this.setState(
        { value: this.state.value, searchKey: this.state.searchKey },
        this.filterUserData
      );
    } else if (this.state.searchKey === "") {
      this.setState({ value: "", searchKey: "default" }, this.filterUserData);
    } else if (this.state.searchKey === "default") {
      this.setState({ value: "", searchKey: "default" }, this.filterUserData);
    }
  };

  handleSearchChange = (e, { value }) => {
    if (value !== "") {
      this.setState(
        { value: value, searchKey: value },
        this.fillAutoSuggestData
      );
    } else {
      this.setState({ value: "", searchKey: "default" });
    }
  };
  fillAutoSuggestData = () => {
    const { AutoSuggestUserData: data, voteStatus, searchKey } = this.state;
    const searchValue = searchKey.toLowerCase();

    const filteredData = data.filter((p) => {
      const ballotMatch = String(p.BallotNumber)
        .toLowerCase()
        .includes(searchValue);

      if (!ballotMatch) return false;

      switch (voteStatus) {
        case VoteStatusEnum['NSubmitted']:
          return p.BallotVoteId === BallotVoteIdThresVal && p.VoteStatus === VoteStatusEnum['SubmittedNSaved'];
        case VoteStatusEnum['Submitted']:
          return p.BallotVoteId > BallotVoteIdThresVal && p.VoteStatus === VoteStatusEnum['Submitted'];
        case VoteStatusEnum['SubmittedNSaved']:
          return p.BallotVoteId > BallotVoteIdThresVal && p.VoteStatus === VoteStatusEnum['SubmittedNSaved'];
        default:
          return true;
      }
    });

    this.setState({
      isLoading: false,
      results: filteredData.slice(0, 10),
    });
  };

  filterUserDataFromResultSelect = () => {
    const {
      AutoSuggestUserData: data,
      voteStatus,
      searchKey,
      value,
      pageSize,
    } = this.state;
    const searchValue = searchKey.toLowerCase();
    const exactValue = value.toLowerCase();

    const filteredData = data.filter((p) => {
      const ballotNumber = String(p.BallotNumber).toLowerCase();

      if (voteStatus === VoteStatusEnum['NSubmitted'])
        return (
          ballotNumber.includes(searchValue) &&
          p.BallotVoteId === BallotVoteIdThresVal &&
          p.VoteStatus === VoteStatusEnum['SubmittedNSaved']
        );

      if (voteStatus === VoteStatusEnum['Submitted'])
        return (
          ballotNumber.includes(searchValue) &&
          p.BallotVoteId > BallotVoteIdThresVal &&
          p.VoteStatus === VoteStatusEnum['Submitted']
        );

      if (voteStatus === VoteStatusEnum['SubmittedNSaved'])
        return (
          ballotNumber.includes(searchValue) &&
          p.BallotVoteId > BallotVoteIdThresVal &&
          p.VoteStatus === VoteStatusEnum['SubmittedNSaved']
        );

      return ballotNumber === exactValue;
    });

    filteredData.sort(
      (a, b) => new Date(a.SubmissionDate) - new Date(b.SubmissionDate)
    );
    const pagedData = paginateData(filteredData, 1, pageSize);

    this.setState({
      VoteHistoryList: pagedData,
      TotalRecords: filteredData.length,
      pageNumber: 1,
    });
  };

  filterUserData = () => {
    const {
      AutoSuggestUserData: data,
      voteStatus,
      searchKey,
      pageSize,
    } = this.state;
    let filteredData = [...data];

    const isDefaultSearch = searchKey === "default";
    const hasSearchKey = !isDefaultSearch;

    if (voteStatus !== VoteStatusAllEnum) {
      filteredData = filteredData.filter((p) => {
        const ballotMatch = hasSearchKey
          ? String(p.BallotNumber)
              .toLowerCase()
              .includes(searchKey.toLowerCase())
          : true;

        if (voteStatus === VoteStatusEnum['NSubmitted']) {
          return ballotMatch && p.BallotVoteId === BallotVoteIdThresVal && p.VoteStatus === VoteStatusEnum['SubmittedNSaved'];
        } else if (voteStatus === VoteStatusEnum['Submitted']) {
          return ballotMatch && p.BallotVoteId > BallotVoteIdThresVal && p.VoteStatus === VoteStatusEnum['Submitted'];
        } else if (voteStatus === VoteStatusEnum['SubmittedNSaved']) {
          return ballotMatch && p.BallotVoteId > BallotVoteIdThresVal && p.VoteStatus === VoteStatusEnum['SubmittedNSaved'];
        }
        return false;
      });
    } else if (voteStatus === -1 && !isDefaultSearch) {
      filteredData = filteredData.filter((p) =>
        String(p.BallotNumber).toLowerCase().includes(searchKey.toLowerCase())
      );
    }

    if (filteredData.length > 1) {
      filteredData.sort(
        (a, b) => new Date(a.SubmissionDate) - new Date(b.SubmissionDate)
      );
    }

    const pagedData = paginateData(filteredData, 1, pageSize) || [];

    this.setState({
      VoteHistoryList: pagedData,
      TotalRecords: filteredData.length,
      pageNumber: 1,
      showNoResults: filteredData.length < 1,
    });
  };

  voteDetailPageChange = (ballot) => {
    this.setState({
      letterBallotshow: true,
      ballotNumber: ballot.BallotNumber,
      ballotVoteStatus: ballot.VoteStatus,
    });
  };

  render() {
    const { hasVoteManagementViewAcess, initialValues } = this.props;
    const { AccountNumber } = initialValues;
    const {
      pageNumber,
      pageSize,
      VoteHistoryList,
      TotalRecords,
      voteStatus,
      isLoading,
      results,
      value,
      searchKey,
      letterBallotshow,
      ballotVoteStatus,
      ballotNumber,
      showNoResults,
    } = this.state;

    const resultRenderer = ({ BallotNumber }) => (
      <div>
        <span>{ManageContent(BallotNumber, searchKey)}</span>
      </div>
    );

    let ManageContent = (str, find) => {
      let result = [];
      for (let i = 0; i < str.length; i++) {
        for (let j = 0; j < find.length; j++) {
          if (i === j) {
            if (str.toLowerCase().indexOf(find.toLowerCase()) === 0) {
              result.push(<b>{str[i]}</b>);
            } else {
              result.push(str[i]);
            }
          }
        }
      }
      result.push(str.slice(find.length, str.length));
      return result;
    };

    return (
      <div data-testid="ViewVoteHistoryComp">
        <div>
          {letterBallotshow && (
            <a
              href="#"
              className="editBtn"
              style={{ width: "32px" }}
              data-testid="backButton"
              onClick={(e) => {
                e.preventDefault();
                this.setState({
                  letterBallotshow: false,
                  ballotNumber: null,
                  ballotVoteStatus: null,
                  searchKey: "",
                  results: [],
                  voteStatus: -1,
                  value: "",
                });
                _func.getInitalData();
              }}
            >
              <Icon name="arrow left" />
            </a>
          )}
          {!letterBallotshow && (
            <>
              <div className="voteHistory">
                <RenderSelect
                  value={voteStatus}
                  options={ViewVoteHisstoryStatusDropDown}
                  onChange={_func.onChangeDropdownBallotStatus}
                />
                <div data-testid="searchUser" className="ui searchBar">
                  <Search
                    className="searchBx autocompleteOff"
                    loading={isLoading}
                    onKeyDown={this.handleKeyDown}
                    onResultSelect={this.handleResultSelect}
                    onSearchChange={_.debounce(this.handleSearchChange, 500, {
                      leading: true,
                    })}
                    results={results}
                    value={value}
                    resultRenderer={resultRenderer}
                    showNoResults={false}
                    noResultsMessage={"No results found"}
                    placeholder="Search by Letter Ballot"
                    minCharacters="1"
                    {...this.props}
                  />
                  <span
                    data-testid="searchIcon"
                    className="seachVoteIcon"
                    onClick={this.handleSearchIcon_Click}
                  ></span>
                </div>
              </div>
              <div className="contentWrapper clearfix">
                <div>
                  <div class="tableWrapper">
                    <table class="customTable" data-testid="customTable">
                      <thead>
                        <tr>
                          <TableHeader
                            headerProps={VoteHistoryColumn}
                            onClickProps={_func.sortByHandler}
                          ></TableHeader>
                        </tr>
                      </thead>
                      <tbody>
                        {VoteHistoryList &&
                          VoteHistoryList.length > 0 &&
                          VoteHistoryList.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item.SubmissionDate || "-"}</td>
                                  <td>
                                    {item.BallotVoteId === 0 && item.VoteStatus === 0 ? (
                                      <>{item.BallotNumber || "-"}</>
                                    ) : (
                                      <a
                                        href="#"
                                        className="ballotNumber"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.voteDetailPageChange(item);
                                        }}
                                      >
                                        {item.BallotNumber || "-"}
                                      </a>
                                    )}
                                  </td>
                                <td className="ballotSubmission">
                                  {item.VoteStatus === 1 &&
                                    item.BallotVoteId > BallotVoteIdThresVal && (
                                      <span>
                                        {ViewHisstoryStatusEnum["1"] || "-"}
                                      </span>
                                    )}
                                  {item.VoteStatus === 0 &&
                                    item.BallotVoteId > BallotVoteIdThresVal && (
                                      <span>
                                        {ViewHisstoryStatusEnum["0"] || "-"}
                                      </span>
                                    )}
                                  {item.VoteStatus === 0 &&
                                    item.BallotVoteId === BallotVoteIdThresVal && (
                                      <span>
                                        {ViewHisstoryStatusEnum["2"] || "-"}
                                      </span>
                                    )}
                                  {hasVoteManagementViewAcess && (
                                    <CustomTooltip
                                      icon={
                                        <span className="ballotSubmissionIcon">
                                          <a
                                            href={`${
                                              process.env.REACT_APP_BTAPP_URL
                                            }/ballotDetail/${encrypt(
                                              `${item.BallotId}`
                                            )}?activePage=1&accountNo=${AccountNumber}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <i className="fa fa-external-link-alt" />
                                          </a>
                                        </span>
                                      }
                                      content="View/Edit"
                                      position="top center"
                                    />
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    {!VoteHistoryList.length && !showNoResults && (
                      <div className="noRecordMessage">
                        Vote submission history not available.
                      </div>
                    )}
                    {showNoResults && (
                      <div className="noRecordMessage">No results found</div>
                    )}
                    {VoteHistoryList && VoteHistoryList.length > 0 && (
                      <section className="pagerWrap" data-testid="pagerWrap">
                        <div className="pager" data-testid="pager">
                          <PaginationShorthand
                            defaultActivePage={pageNumber}
                            totalPages={Math.ceil(TotalRecords / pageSize)}
                            onPageChange={_func.onPageChangeHandler}
                          />
                        </div>
                        <div className="itemPerPage" data-testid="itemPerPage">
                          <RenderSelect
                            value={pageSize}
                            options={ItemsPerPage}
                            onChange={_func.onChangeNumberOfItemsPerPage}
                          />
                          <span className="itemsPerPage">items per page</span>
                        </div>
                        <div className="totalPage" data-testid="totalPage">
                          {(pageNumber - 1) * pageSize +
                            1 +
                            " - " +
                            ((pageNumber - 1) * pageSize +
                              VoteHistoryList.length) +
                            " of "}
                          {VoteHistoryList ? TotalRecords + " items" : ""}
                        </div>
                      </section>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          {letterBallotshow && (
            <ViewVotetHistoryDetails
              {...this.props}
              ballotNumber={ballotNumber}
              ballotVoteStatus={ballotVoteStatus}
            />
          )}
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: "memberVoteeHistory",
})(MemberVoteHistory);
